enum EApprovalCategory {
  ROSTERED = "ROSTERED",
  SUBMITTED = "SUBMITTED",
}

export default EApprovalCategory;
